import { IState } from "../..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../../app/store";
import { ExportOperationsReviewListState } from "../ShipmentReconciliationState";
import ShipmentReconciliationService from "app/data/shipment-reconciliation/shipmentReconciliationService";
import { OperationsReviewWorkItemRequest } from "app/data/shipment-reconciliation/models";

const initialState: ExportOperationsReviewListState = {
  loading: false,
  loadingFailed: false,
  loaded: false
};

const shipmentReconciliationService = ShipmentReconciliationService.getInstance();

export const exportOperationsReviewListSlice = createSlice({
  name: "exportOperationsReviewList",
  initialState,
  reducers: {
    exportOperationsReviewListResetState: (state) => initialState,
    exportOperationsReviewListLoadingStarted: (state) => {
      state.loading = true;
      state.loadingFailed = false;
      state.loaded = false;
    },
    exportOperationsReviewListLoadingSucceed: (state) => {
      state.loaded = true;
      state.loading = false;
      state.loadingFailed = false;
    },
    exportOperationsReviewListLoadingFailed: (state) => {
      state.loading = false;
      state.loadingFailed = true;
    }
  },
});

export const {
  exportOperationsReviewListResetState,
  exportOperationsReviewListLoadingStarted,
  exportOperationsReviewListLoadingSucceed,
  exportOperationsReviewListLoadingFailed
} = exportOperationsReviewListSlice.actions;

export const exportOperationsReviewListSelector = (state: IState) => state.exportOperationsReviewList;

export const downloadOperationsReviewCsv = (
  requestData: OperationsReviewWorkItemRequest,
  onError?: (error: string) => void
): AppThunk => async (dispatch) => {
  try {
    dispatch(exportOperationsReviewListLoadingStarted());
    const response =  await shipmentReconciliationService.getOperationsReviewListExport(requestData);
    const pdfBlob = new Blob([response.data], { type: "text/csv" });
    const url = window.URL.createObjectURL(pdfBlob);
    const tempLink = document.createElement("a");
    tempLink.href = url;
    tempLink.setAttribute(
      "download",
      "Operations Review.csv"
    );
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(url);
    dispatch(exportOperationsReviewListLoadingSucceed());
  } catch (error) {
    dispatch(exportOperationsReviewListLoadingFailed());
    onError && onError("Internal Server Error, re-try the action or contact support")
  }

};

const exportOperationsReviewListReducer = exportOperationsReviewListSlice.reducer;
export default exportOperationsReviewListReducer;